/**
 * Intake Source API Client — J7-W7
 *
 * Thin wrapper around /api/v1/intake/* using apiFetch (via base helpers).
 * All requests carry X-Organization-Id automatically.
 */

import { fetchJson, mutate, qs } from './base-roros.service';

// ─── DTOs ────────────────────────────────────────────────────────────────────

export interface RorosIntakeSourceDTO {
  id: string;
  orgId: string;
  title: string;
  description: string | null;
  connectorType: string;
  connectorConfig: Record<string, unknown> | null;
  status: 'active' | 'archived';
  createdBy: string | null;
  updatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface RorosIntakeScanRoutineDTO {
  id: string;
  status: string;
  lastRunAt: string | null;
  nextRunAt: string | null;
  runCount: number;
}

export interface CreateIntakeSourcePayload {
  title: string;
  description: string;
  connector_type?: 'manual' | 'webhook' | 'email' | 'api';
  connector_config?: Record<string, unknown> | null;
}

export interface UpdateIntakeSourcePayload {
  title?: string;
  description?: string;
  connector_type?: 'manual' | 'webhook' | 'email' | 'api';
  connector_config?: Record<string, unknown> | null;
}

export interface ListIntakeSourcesParams {
  status?: 'active' | 'archived' | 'all';
}

// ─── Service ─────────────────────────────────────────────────────────────────

export const RorosIntakeService = {
  listIntakeSources: (params?: ListIntakeSourcesParams) =>
    fetchJson<RorosIntakeSourceDTO[]>(
      `/api/v1/intake/sources${qs(params as Record<string, string> | undefined)}`,
    ),

  createIntakeSource: (payload: CreateIntakeSourcePayload) =>
    mutate<RorosIntakeSourceDTO>('/api/v1/intake/sources', 'POST', payload),

  getIntakeSource: (id: string) =>
    fetchJson<RorosIntakeSourceDTO>(`/api/v1/intake/sources/${id}`),

  updateIntakeSource: (id: string, payload: UpdateIntakeSourcePayload) =>
    mutate<RorosIntakeSourceDTO>(`/api/v1/intake/sources/${id}`, 'PUT', payload),

  disableIntakeSource: (id: string) =>
    mutate<RorosIntakeSourceDTO>(`/api/v1/intake/sources/${id}/disable`, 'POST'),

  // B5: returns null when no routine exists (pre-migration-297 tenant, 200 with data:null).
  getIntakeScanRoutine: () =>
    fetchJson<RorosIntakeScanRoutineDTO | null>('/api/v1/intake/scan-routine'),
};
